<template>
    <div class="bg-primary">
        <div class="h-layout h-layout-full-height h-layout-auth">
            <router-view />
        </div>
        <div class="bg-circle-animation d-none d-md-block">
            <div class="circle" style="animation-delay:0s"></div>
            <div class="circle" style="animation-delay:1.5s"></div>
            <div class="circle" style="animation-delay:3s"></div>
            <div class="circle" style="animation-delay:4.5s"></div>
        </div>
    </div>
</template>

<script>
    export default {

    }
</script>

<style lang="stylus">
    @keyframes circleScaleIn
        0%
            width 400px
            height 400px
            opacity 0

        25%
            width 600px
            height 600px
            opacity .75

        100%
            width 1200px
            height 1200px
            opacity 0

    .bg-circle-animation
        absolute top 0 left 0
        size 100%
        z-index 0
        overflow hidden

    .bg-circle-animation .circle
        absolute top 50% left 50%
        size 400px
        transform translate(-50%, -50%)
        border-radius 50%
        box-shadow 0 0 0 1px darken($primary, 85%)
        opacity 0
        animation circleScaleIn 8s infinite linear

    .h-layout-auth
        position relative
        z-index 1
        display flex
        align-items center
</style>